/**
 * Copyright Highway9 Networks Inc.
 */
import { AbilityBuilder, createMongoAbility } from "@casl/ability";
import type { PermissionsMap } from "~/types/rbac";
import type { Permission } from "~/types/user";
import type { AppAbility, AppAction, AppSubject } from "../types/rbac";

export function createEmptyAbility(): AppAbility {
  return createMongoAbility<AppAbility>([]);
}

/**
 * Build a CASL ability from the permissions array returned by the user API.
 */
export function defineAbilityFromPermissions(permissions: Permission[] | null | undefined): AppAbility {
  if (!permissions?.length) {
    return createEmptyAbility();
  }

  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  for (const entry of permissions) {
    for (const action of entry.permissions) {
      can(action, entry.objectType);
    }
  }

  return build();
}

/**
 * Build a CASL ability from the normalized permissions map stored in Redux.
 */
export function defineAbilityFromPermissionsMap(permissionsMap: PermissionsMap): AppAbility {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);

  for (const [subject, actions] of Object.entries(permissionsMap)) {
    if (!actions) continue;
    for (const [action, allowed] of Object.entries(actions)) {
      if (allowed) {
        can(action as AppAction, subject as AppSubject);
      }
    }
  }

  return build();
}
